import React, { useState, useEffect } from "react";
import axios from "axios";
import "./css/BellScheduleForm.css";
import config from "../config"; // Импортируем API_URL
const BellScheduleForm = ({ groupId, onClose }) => {
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBellSchedule();
  }, []);

  const fetchBellSchedule = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${config.API_URL}/bell_schedule`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSchedule(response.data.length > 0 ? response.data : [{ weekday: 1, order: 1, start_time: "", end_time: "" }]);
    } catch (error) {
      console.error("Ошибка загрузки расписания звонков:", error);
    }
  };

  const handleChange = (index, field, value) => {
    setSchedule((prevSchedule) =>
      prevSchedule.map((entry, i) => (i === index ? { ...entry, [field]: value } : entry))
    );
  };

  const fillWeekdays = () => {
    const mondaySchedule = schedule.filter((entry) => entry.weekday === 1);

    if (mondaySchedule.length === 0) {
      alert("Сначала заполните понедельник!");
      return;
    }

    setSchedule((prevSchedule) => {
      const newSchedule = [...prevSchedule];

      for (let weekday = 2; weekday <= 5; weekday++) {
        mondaySchedule.forEach((mondayEntry) => {
          const existingEntry = newSchedule.find(
            (entry) => entry.weekday === weekday && entry.order === mondayEntry.order
          );

          if (!existingEntry) {
            newSchedule.push({
              weekday,
              order: mondayEntry.order,
              start_time: mondayEntry.start_time,
              end_time: mondayEntry.end_time,
            });
          }
        });
      }

      return newSchedule;
    });
  };

  const addRow = () => {
    setSchedule((prev) => [...prev, { weekday: 1, order: prev.length + 1, start_time: "", end_time: "" }]);
  };

  const deleteRow = (index) => {
    setSchedule((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      await axios.post(`${config.API_URL}/bell_schedule/edit`, { schedule }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Расписание звонков обновлено!");
      onClose();
    } catch (error) {
      console.error("Ошибка при добавлении звонков:", error);
      alert("Ошибка при обновлении звонков!");
    }
  };

  return (
    <div className="modal-bell">
      <h2 className="second-text">Редактирование расписания звонков</h2>

      <button className="sliding-button fillbell-btn" onClick={fillWeekdays}>
        Заполнить будни
      </button>

      {schedule.length === 0 ? (
        <p>Загрузка...</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="bell-schedule-container">
            {schedule.map((entry, index) => (
              <div key={index} className="bell-schedule-row">
                <select value={entry.weekday} onChange={(e) => handleChange(index, "weekday", Number(e.target.value))}>
                  <option value="1">Понедельник</option>
                  <option value="2">Вторник</option>
                  <option value="3">Среда</option>
                  <option value="4">Четверг</option>
                  <option value="5">Пятница</option>
                  <option value="6">Суббота</option>
                </select>

                <input
                  type="number"
                  value={entry.order}
                  onChange={(e) => handleChange(index, "order", Number(e.target.value))}
                  required
                />

                <input
                  type="time"
                  value={entry.start_time}
                  onChange={(e) => handleChange(index, "start_time", e.target.value)}
                  required
                />

                <input
                  type="time"
                  value={entry.end_time}
                  onChange={(e) => handleChange(index, "end_time", e.target.value)}
                  required
                />

                <button type="button" className="sliding-button edit-bell-delete-btn" onClick={() => deleteRow(index)}>
                  🗑
                </button>
              </div>
            ))}
          </div>

          <button type="button" className="sliding-button bell-add-btn" onClick={addRow}>
            ➕ Добавить звонок
          </button>

          <div className="button-group">
            <button className="sliding-button edit-bell-save-btn" type="submit">{loading ? "Сохранение..." : "Сохранить"}</button>
            <button type="button" className="sliding-button calcel-bell-save-btn" onClick={onClose}>
              Отмена
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default BellScheduleForm;
